import { configureAuth } from 'lib/react-query-auth';
import { userFn, loginFn, tokenFn, registerFn, logoutFn } from 'features/auth/utils/token';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';

const { AuthLoader } = configureAuth({
  userFn,
  loginFn,
  tokenFn,
  registerFn,
  logoutFn,
});

export const AuthLoaderForms = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const loginUrl = `/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`;
  return (
    <AuthLoader
      renderLoading={() => (
        <Loading>
          <CircularProgress />
        </Loading>
      )}
      renderLogin={() => <Navigate to={loginUrl} replace />}
      renderCompanySelect={() => <Navigate to="/switchcompany" replace />}
    >
      {children}
    </AuthLoader>
  );
};

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #fbf9f7;
`;
